(function () {
  const ZOOM = 2.5;
  const SIZE = 250;

  function attach(host) {
    const img = host.querySelector('img');
    if (!img) return;

    let lens = host.querySelector('.dbm-lens');
    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'dbm-lens';
      host.appendChild(lens);
    }

    function updateBg() {
      const src = img.currentSrc || img.src;
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.style.backgroundSize = (img.clientWidth * ZOOM) + 'px ' + (img.clientHeight * ZOOM) + 'px';
    }

    function onMove(e) {
      const r = img.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) {
        lens.classList.remove('is-active');
        return;
      }
      const hostRect = host.getBoundingClientRect();
      lens.style.left = (e.clientX - hostRect.left) + 'px';
      lens.style.top = (e.clientY - hostRect.top) + 'px';
      lens.style.backgroundPosition = '-' + (x * ZOOM - SIZE / 2) + 'px -' + (y * ZOOM - SIZE / 2) + 'px';
      lens.classList.add('is-active');
    }

    function onLeave() { lens.classList.remove('is-active'); }

    img.addEventListener('pointerenter', updateBg);
    img.addEventListener('pointermove', onMove);
    img.addEventListener('pointerleave', onLeave);
    window.addEventListener('resize', updateBg);
  }

  function init() {
    if (window.matchMedia('(hover: none)').matches || window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('[data-dbm-lens]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
